;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:dotorg-next":true});}catch(e){}}();enum NewsletterList {
  // NOTE: if newsletters are added or removed, be sure to update listToGroupId() in
  // app/(main)/api/newsletter/signup/route.ts accordingly.
  default = 'default',
  drama = 'drama',
  science = 'science',
  mystery = 'mystery',
}

export default NewsletterList
